var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeightDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon-in-row",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#CFD8DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0332 10.5555C18.901 10.5555 18.7843 10.6255 18.7143 10.7344L18.6599 10.851L14.631 19.9121C14.5066 20.1377 14.4288 20.3866 14.4288 20.6588C14.4288 21.5221 15.1288 22.2221 15.9921 22.2221C16.7388 22.2221 17.3688 21.6932 17.5166 20.9855L17.5243 20.9621L19.4221 10.9444C19.4221 10.7266 19.251 10.5555 19.0332 10.5555ZM7.44434 13.6666L8.99989 15.2221C11.2399 12.9821 14.281 12.0488 17.1899 12.4066L18.1154 10.3221C14.3588 9.65325 10.3532 10.7655 7.44434 13.6666ZM22.9999 15.2221L24.5554 13.6666C23.2799 12.391 21.7943 11.4732 20.2077 10.8899L19.7954 13.0832C20.9621 13.5655 22.051 14.2732 22.9999 15.2221ZM19.8888 18.3332L21.4443 16.7777C20.8221 16.1555 20.1221 15.6732 19.3754 15.3077L18.9477 17.5788C19.2743 17.7888 19.5932 18.0377 19.8888 18.3332ZM10.5554 16.7777L12.111 18.3332C12.9899 17.4544 14.1021 16.941 15.2454 16.7777L16.241 14.5377C14.1954 14.4755 12.1188 15.2144 10.5554 16.7777Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightDisabled);
export default __webpack_public_path__ + "static/media/weight_disabled.a1d5195b.svg";
export { ForwardRef as ReactComponent };